module.exports = __webpack_public_path__ + "img/20190513_190124.1d7869c5.jpg";